/* eslint-disable react-hooks/refs */

import { useLayoutEffect, useRef } from 'react';

import { useWindowVirtualizer } from '@tanstack/react-virtual';

import { SIZES } from '@app/constants';

import { type Merchant } from '@api/services/merchants';

const useVirtualizedMerchantsList = (items: Merchant[]) => {
  const listRef = useRef<HTMLDivElement | null>(null);
  const listOffsetRef = useRef(0);

  const virtualizer = useWindowVirtualizer({
    count: items.length,
    overscan: 5,
    estimateSize: () => SIZES.merchantCardHeight,
    scrollMargin: listOffsetRef.current,
    useAnimationFrameWithResizeObserver: true,
    enabled: Boolean(items.length),
    getItemKey: (index) => items[index].id,
    gap: 24,
  });

  useLayoutEffect(() => {
    listOffsetRef.current = listRef.current?.offsetTop ?? 0;
  }, []);

  return {
    listRef,
    virtualizer,
  };
};

export default useVirtualizedMerchantsList;
